import type { TemplateId } from "../../templates/index.js";
import type { BuildContext } from "../types.js";
import { buildHookRevealHtml, HOOK_REVEAL_DURATION_SEC } from "./hookReveal.js";
import { buildBigStatementHtml, BIG_STATEMENT_DURATION_SEC } from "./bigStatement.js";
import { buildProblemSolutionHtml, PROBLEM_SOLUTION_DURATION_SEC } from "./problemSolution.js";
import { buildListBangerHtml, listBangerDurationSec } from "./listBanger.js";
import { buildFeatureShowcaseHtml, featureDurationSec } from "./featureShowcase.js";
import { buildPatternInterruptHtml, PATTERN_INTERRUPT_DURATION_SEC } from "./patternInterrupt.js";
import { buildCountdownCtaHtml, COUNTDOWN_DURATION_SEC } from "./countdownCTA.js";
import { buildBeforeAfterHtml, BEFORE_AFTER_DURATION_SEC } from "./beforeAfter.js";
import { buildTestimonialCardHtml, TESTIMONIAL_DURATION_SEC } from "./testimonialCard.js";
import type { ListBangerProps, FeatureProps } from "../../templates/index.js";

export type TemplateBuilder = {
  build: (props: unknown, ctx: Omit<BuildContext, "durationSec">) => string;
  durationSeconds: (props: unknown) => number;
};

export const HYPERFRAMES_TEMPLATES: Record<TemplateId, TemplateBuilder> = {
  HookReveal: {
    build: buildHookRevealHtml,
    durationSeconds: () => HOOK_REVEAL_DURATION_SEC,
  },
  BigStatement: {
    build: buildBigStatementHtml,
    durationSeconds: () => BIG_STATEMENT_DURATION_SEC,
  },
  ProblemSolution: {
    build: buildProblemSolutionHtml,
    durationSeconds: () => PROBLEM_SOLUTION_DURATION_SEC,
  },
  ListBanger: {
    build: buildListBangerHtml,
    durationSeconds: (p) => listBangerDurationSec(p as ListBangerProps),
  },
  FeatureShowcase: {
    build: buildFeatureShowcaseHtml,
    durationSeconds: (p) => featureDurationSec(p as FeatureProps),
  },
  PatternInterrupt: {
    build: buildPatternInterruptHtml,
    durationSeconds: () => PATTERN_INTERRUPT_DURATION_SEC,
  },
  CountdownCTA: {
    build: buildCountdownCtaHtml,
    durationSeconds: () => COUNTDOWN_DURATION_SEC,
  },
  BeforeAfter: {
    build: buildBeforeAfterHtml,
    durationSeconds: () => BEFORE_AFTER_DURATION_SEC,
  },
  TestimonialCard: {
    build: buildTestimonialCardHtml,
    durationSeconds: () => TESTIMONIAL_DURATION_SEC,
  },
};

export function isHyperframesPorted(_id: TemplateId): boolean {
  return true;
}
